import { render } from "./ProjectsAssetsStatus.vue?vue&type=template&id=2e755211"
import script from "./ProjectsAssetsStatus.vue?vue&type=script&lang=js"
export * from "./ProjectsAssetsStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__